import * as React from "react";
const SvgFiRrSkullCow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skull-cow_svg__a)">
      <path
        fill="#062147"
        d="M17 10.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 0M8.5 9a1.5 1.5 0 1 0 .001 3A1.5 1.5 0 0 0 8.5 9m15.343-7.751a5 5 0 0 1-4.404 3.732l2.328 6.174a4.014 4.014 0 0 1-1.98 4.922c-.037.019-1.927.683-1.927.683l-.875 4.08a4.02 4.02 0 0 1-3.91 3.16h-2.15a4.02 4.02 0 0 1-3.912-3.16l-.874-4.081s-1.89-.663-1.928-.682a4.01 4.01 0 0 1-1.986-4.9l2.333-6.186A5 5 0 0 1 .032 1.249 1 1 0 1 1 1.968.75 3 3 0 0 0 4.874 3H19c1.37 0 2.564-.925 2.905-2.25a1.005 1.005 0 0 1 1.218-.72c.535.139.857.685.72 1.219m-3.956 10.588L17.309 5H6.69l-2.587 6.859c-.317.907.087 1.938.95 2.4l1.746.61a2.01 2.01 0 0 1 1.295 1.469l.875 4.08a2.01 2.01 0 0 0 1.956 1.58h2.15a2.01 2.01 0 0 0 1.955-1.58l.875-4.08A2.01 2.01 0 0 1 17.2 14.87l1.744-.61a2 2 0 0 0 .942-2.423"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skull-cow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkullCow;
